import { combineReducers } from "redux";
import { viewModeValue } from "./viewModeReducer";
import { trailerViewMode } from "./trailerModeReducer";
import { cartReduceHandler } from "./cartReducer";
import { loginViewMode } from "./loginViewReducer";
import { movieDetailsViewMode } from "./viewMovieDetailsReducers";
import { mobileFilterReduce } from "./mobileFilterReducer";
import { nowShowingMoviesReduce } from "./nowShowingMoviesReaducers";
import { comingSoonMovieReduce } from "./comingsoonMoviesReducers";
import { grandTotalData } from "./grandTotalReducers";

export default combineReducers({
  viewModeValue,
  trailerViewMode,
  cartReduceHandler,
  loginViewMode,
  movieDetailsViewMode,
  mobileFilterReduce,
  nowShowingMoviesReduce,
  comingSoonMovieReduce,
  grandTotalData,
});
